import { Component, computed, inject, input, OnInit } from "@angular/core";
import { StockTypeFormComponent } from "../../components/stock-type-form/stock-type-form.component";
import { StockTypeForm } from "../../models/stock-type-form.model";
import { PageHeaderComponent } from "@app/shared-core/components/page-header/page-header.component";
import { SxwFormComponent } from "@app/kernel/form/components/sxw-form/sxw-form.component";
import { BreadCrumbComponent } from "@kernel/tools/bread-crumb/components/bread-crumb/bread-crumb.component";
import { viewBreadCrumb } from "@app/applications/stock/domains/stock-type/configs/bread-crumb-stock-type.config";
import { IStockType } from "@app/shared/settings/stock-type/interfaces/stock-type.interface";
import { StockTypeRoutePaths } from "@app/applications/stock/domains/stock-type/stock-type-route-paths";
import { PageTitleService } from "@app/shared/general/services";

@Component({
  selector: "app-view-stock-type",
  imports: [StockTypeFormComponent, PageHeaderComponent, SxwFormComponent, BreadCrumbComponent],
  templateUrl: "./view-stock-type.component.html",
  styleUrl: "./view-stock-type.component.scss",
  providers: [StockTypeForm],
})
export class ViewStockTypeComponent implements OnInit {
  /**
   * Page title service for clean title management
   */
  pageTitle = inject(PageTitleService);
  /**
   * Injecting the CustomerTypeForm model for managing form state
   */
  public readonly formModel = inject(StockTypeForm);

  /**
   * Come from resolver as input
   */
  stockType = input.required<IStockType>();
  stockTypeName = computed(() => this.stockType()?.name ?? "");

  protected readonly breadCrumb = viewBreadCrumb(this.stockType);

  constructor() {}

  /**
   * Angular lifecycle hook to initialize the form with customerType data.
   */
  ngOnInit() {
    this.formModel.setEntity(this.stockType());
    this.formModel.formGroup().disable({ emitEvent: false });
    this.pageTitle.setupDynamicTitle("STOCK_TYPE.TITLES.VIEW", this.stockTypeName);
  }

  protected readonly StockTypeRoutePaths = StockTypeRoutePaths;
}
